// todo: maybe change to VIDEO_WINDOW_OPEN
import {
    VIEW_USER_REQUEST
} from '../constants/streaming';
import {LOGIN_SUCCESS} from "../constants/general";

const currentUserMiddleware = (store) => (next) => (action) => {
    if (action.type === VIEW_USER_REQUEST) {
        let currentUser = store.getState().currentUser;
        next({ ...action, currentUser });
        return;
    }

    if (action.type === LOGIN_SUCCESS) {
        if (action.user.other_connections) {
            store.dispatch({type: "CLOSE_OTHER_CONNECTIONS", user: action.user});
        }
    }

    next(action)
};

export default currentUserMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/currentUser.js